import { render } from "./PremiumSettings.vue?vue&type=template&id=eaf2c2ea&ts=true"
import script from "./PremiumSettings.vue?vue&type=script&lang=ts"
export * from "./PremiumSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__